import React from 'react';

import { FormBase } from '../Interface';
import { EmployeePage } from './EmployeePage';
import { useEmployee } from '../../hooks/useEmployee';
import EmployeeReports from './EmployeeReports';

export const EmployeeMain = () => {
  const employeeState = useEmployee();

  return (
    <FormBase
      name="Employee"
      leftPanelContent={<EmployeePage employeeState={employeeState} />}
      rightPanelContent={<> {!employeeState.isLoading && <EmployeeReports employeeState={employeeState} />}</>}
    />
  );
};
